import { render, staticRenderFns } from "./form-zbxmxx.vue?vue&type=template&id=2f190464&scoped=true&"
import script from "./form-zbxmxx.vue?vue&type=script&lang=js&"
export * from "./form-zbxmxx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f190464",
  null
  
)

export default component.exports